const solidBlack = "1px solid black";
const getAssessmentPageObject = (theme) => {
  return {
    bottomBar: {
      padding: "10px 30px",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      borderTop: solidBlack,
    },
    nextButton: {
      backgroundColor: "#d9dbdc",
      color: "#878888",
    },

    nextButtonActive: {
      backgroundColor: "#09306d",
      color: " white",
    },
    backButton: {
      borderColor: "#09306d",
      color: "#09306d",
    },
    bottomBarButton: {
      textTransform: "none",
      fontWeight: "bold",
      padding: "10px",
    },
    horizonalLine: {
      backgroundColor: "#0304041a",
      color: "#0304041a",
      borderColor: "#0304041a",
    },
    subSectionContainer: {
      marginTop: "40px",
      paddingBottom: "15px",
    },
    exprtSubSectionContainer: {
      marginTop: "10px",
      paddingBottom: "5px",
    },
    optionsContainer: {
      display: "flex",
      justifyContent: "center",
    },
    subSectionHeadingContainer: {
      display: "flex",
      justifyContent: "space-between",
    },
    subSectionHeadingTextContainer: {
      display: "flex",
      gap: 20,
      alignItems: "baseline",
      h2: {
        fontWeight: "400",
        fontSize: "28px",
        margin: 0,
        color: "black",
      },
    },
    bodyAreaText: {
      marginBottom: "20px",
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0px",
      color: "#030404",
    },
    subSectionInfoContainer: {
      display: "flex",
      gap: "4px",
      color: "#01579B",
      alignItems: "center",
      cursor: "pointer",
    },
    whatsNewStyle: {
      display: "flex",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "0px",
      color: "#0D47A1",
      cursor: "pointer",
    },
    addNote: {
      color: "#0D47A1",
      borderColor: "#0D47A1",
      textTransform: "none",
      padding: "5px 15px",
    },
    questionsContainer: {
      backgroundColor: "white",
      borderRadius: "5px",
      border: "1px solid #0304041A",
      boxShadow: solidBlack,
      margin: "20px 0px",
    },
    exprtQuestionsContainer: {
      backgroundColor: "white",
      borderRadius: "5px",
      border: "1px solid #0304041A",
      boxShadow: solidBlack,
    },
    questionsTextContainer: {
      margin: "8px 0px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    expertQuestionsTextContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    questionsText: {
      display: "flex",
      gap: 4,
      color: "black",
      fontSize: "16px",
    },
    questionsDescription: {
      margin: 0,
      marginBottom: "40px",
      textAlign: "left",
      color: "#546E7A",
    },
  };
};

export const getAssessmentPageStyle = getAssessmentPageObject;
